import { useEffect, useRef } from 'react'
import { getEventPath } from '../browser'

export const useOutsideClick = (onOutsideClick: () => void, id?: string, mobile?: boolean) => {
  const outsideClickRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (mobile) return

    const handle = (event: MouseEvent) => {
      const path = getEventPath(event)

      // 1) Найдём, попал ли клик внутрь какой-нибудь модалки и её id
      const clickedModalId = path.find((node) => {
        if (!(node instanceof HTMLElement)) return false

        return typeof node.dataset?.modalId !== 'undefined'
      }) as HTMLElement | undefined

      if (clickedModalId) {
        const clickedId = clickedModalId.dataset.modalId!
        // если кликнули внутри другой модалки — игнорируем

        if (clickedId !== id) return
        // если клик внутри текущей модалки — ничего не делаем (не закрываем)
        // но ниже мы проверим containment и не вызовем onOutsideClick, так что тут можно просто continue
      }

      // 2) Если клик вне текущей модалки — закрыть
      const target = event.target as Node

      if (outsideClickRef.current && !outsideClickRef.current.contains(target)) {
        onOutsideClick()
      }
    }

    document.addEventListener('mousedown', handle)

    return () => document.removeEventListener('mousedown', handle)
  }, [onOutsideClick, id, mobile])

  return { outsideClickRef }
}
